import { Injectable } from '@angular/core';
import * as signalR from "@microsoft/signalr"
import { ToastrService } from 'ngx-toastr';
import { Notificacion } from '../models/notificacion';
import { environment } from '../../environments/environment';
import { Usuario } from '../models/usuario';
import { Router } from '@angular/router';
import { Grafica } from '../models/graficas';

@Injectable({
    providedIn: 'root'
})
export class SignalrService {
    private hubConnection!: signalR.HubConnection;
    constructor(private toastr: ToastrService, private _router: Router) { }
    public startConnection = () => {
        this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(environment.url.replace('/api', '') + 'Notify', {
                skipNegotiation: true,
                transport: signalR.HttpTransportType.WebSockets
            })
            .build();
        this.hubConnection
            .start()
            .then(() => console.log('Conexión iniciada'))
            .then(() => this.hubConnection.invoke('getConnectionId')
                .then(function (connectionId) {
                    localStorage.setItem('connectionId', connectionId);
                }))
            .then(() => this.hubConnection.invoke("ActualizaConexion",
                ((JSON.parse(localStorage.getItem('identity') as string) as Usuario) != undefined) ? (JSON.parse(localStorage.getItem('identity') as string) as Usuario).correo : "",
                localStorage.getItem('connectionId') as string))
            .catch(err => console.log('Error al iniciar la conexión: ' + err))
    }

    public addNotificacionesListner = () => {
        this.hubConnection.on('SendMessage', (notificacion: Notificacion) => {
            this.showNotification(notificacion);
        });
    }
    public addGraficasListner = () => {
        this.hubConnection.on('SendGrafica', (graficas: Grafica) => {
            localStorage.setItem('graficas', JSON.stringify(graficas));
        });
    }
    showNotification(notificacion: Notificacion) {
        let identity = JSON.parse(localStorage.getItem('identity') as string) as Usuario;
        if (identity != null) {
            if (notificacion.tipo == 1) {
                localStorage.setItem('recargaNotificaciones', "1");
                this.toastr.success(notificacion.mensaje);
            }
            if (notificacion.tipo == 2) {
                localStorage.setItem('recargaNotificaciones', "1");
                this.toastr.warning(notificacion.mensaje);
            }
            if (notificacion.tipo == 3) {
                localStorage.setItem('recargaNotificaciones', "1");
                this.toastr.error(notificacion.mensaje);
            }
            if (notificacion.tipo == 4) {
                localStorage.setItem('recargaNotificaciones', "1");
                this.toastr.info(notificacion.mensaje);
            }
            if (notificacion.tipo == 5) {
                alert(notificacion.mensaje);
                localStorage.removeItem('identity');
                localStorage.removeItem('token');
                this._router.navigate(['/login']);
            }
        }
    }
}

